import { useAtomValue } from 'jotai';
import { ReactNode, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { userHasVideoAccessAtom } from '@/atoms/user';
import { Loading } from '../translations/Generic';

const ProtectedVideoRouteWrapper = ({ component }: { component: ReactNode }) => {
  const userHasVideoAccess = useAtomValue(userHasVideoAccessAtom);

  if (!userHasVideoAccess) return <Navigate to="/" replace />;

  return component;
};

export const ProtectedVideoRoute = ({ component }: { component: ReactNode }) => (
  <Suspense fallback={<Loading />}>
    <ProtectedVideoRouteWrapper component={component} />
  </Suspense>
);
